import { TrellusSlot } from './TrellusSlot';

/**
 * Page-top wrapper around the `gong-connection` slot. Terra adds NO text or
 * status of its own: it only styles what the extension reports through the
 * injected mount's `data-state`. Visibility is CSS-only (`index.css`,
 * `[data-trellus-gong-banner]`): hidden when the slot is empty (extension
 * absent), connected, or connecting; a warning bar when disconnected, with the
 * extension's own sign-in action inside.
 */
export function GongConnectionBanner() {
  return (
    <div
      data-trellus-gong-banner
      className="flex shrink-0 items-center gap-3 border-b border-border-warning bg-bg-warning px-4 py-2 text-content-warning"
    >
      <TrellusSlot kind="gong-connection" />
    </div>
  );
}
